import {
  differenceInMinutes,
  differenceInMonths,
  getDate,
  getDay,
  setDate,
  setHours,
  setMinutes,
  setMonth,
  startOfMonth
} from 'date-fns';
import { NUMBER_OF_DAYS_IN_WEEK } from '../../constants';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';
import { numDayOfWeekInMonth } from '../../utils/num-day-of-week-in-month';

export const nthDayInMonth = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInMonths = differenceInMonths(endDate, startDate);
  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);

  const monthPassedFromStart = differenceInMonths(userDate, startDate);

  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();

  const startOfMonthDate = startOfMonth(userDate);

  const firstWeekDates = [];
  for (let i = 1; i <= NUMBER_OF_DAYS_IN_WEEK; i++) {
    const date = setDate(startOfMonthDate, i);
    const weekDay = getDay(date);
    firstWeekDates[weekDay] = i;
  }

  const startDateWeekday = getDay(startDate);
  const startDateDay = getDate(startDate);
  const nth = numDayOfWeekInMonth(startDateDay);

  const dayInThisMonth =
    firstWeekDates[startDateWeekday] + NUMBER_OF_DAYS_IN_WEEK * (nth - 1);

  const startDateInThisMonth = setMinutes(
    setHours(setDate(userDate, dayInThisMonth), startHour),
    startMinutes
  );

  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDurationInMinutes * 60 * 1000
  );

  if (scheduleRepeatEnds === 'onDate') {
    const value =
      userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime();
    return !value;
  }

  if (scheduleRepeatEnds === 'afterOccurrences') {
    const endRepeatMonthDate = setMonth(
      startDate,
      startDate.getMonth() + freq * Number(scheduleRepeatEndsOccurrences)
    );
    const firstWeekDates = [];
    for (let i = 1; i <= 7; i++) {
      const date = setDate(startOfMonthDate, i);
      const weekDay = getDay(date);
      firstWeekDates[weekDay] = i;
    }

    const startDateWeekday = getDay(startDate);
    const startDateDay = getDate(startDate);
    const nth = numDayOfWeekInMonth(startDateDay);

    const dayInThisMonth = firstWeekDates[startDateWeekday] + 7 * (nth - 1);

    const startDateInThisMonth = setMinutes(
      setHours(setDate(endRepeatMonthDate, dayInThisMonth), startHour),
      startMinutes
    );

    if (userDate.getTime() > startDateInThisMonth.getTime()) {
      return false;
    }
  }

  return (
    userDate.getTime() >= startDate.getTime() &&
    userDate.getTime() >= startDateInThisMonth.getTime() &&
    userDate.getTime() <= endDateInThisMonth.getTime() &&
    monthPassedFromStart % freq <= viewDurationInMonths
  );
};
